export function delayForMilliseconds(micoseconds: number) {
  return new Promise((resolve) => setTimeout(resolve, micoseconds));
}

interface IPlayCounter {
  setCountStep: (value: number) => void;
  setCountValue: (value: string) => void;
}

const playCounter = async ({ setCountStep, setCountValue }: IPlayCounter) => {
  const tick = async () => {
    await delayForMilliseconds(300);
    setCountStep(1);
    await delayForMilliseconds(300);
    setCountStep(2);
    await delayForMilliseconds(300);
  };

  const next = async (value: string) => {
    setCountStep(0);
    await delayForMilliseconds(100);
    setCountValue('');
    await delayForMilliseconds(100);
    setCountValue(value);
  };

  await tick();
  await next('2');

  await tick();
  await next('1');

  await tick();
  await delayForMilliseconds(300);
  setCountStep(0);
  await delayForMilliseconds(500);
};

export default playCounter;
